import { LAYOUTS, } from "@voltmoney/types";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTIONS } from "./types";
import { closeModal, goHome, loginGoogle, needHelp, otherEmail } from "./actions";
import SharedPropsService from "../../../SharedPropsService";
import { getContactUsDetails, isFromTDLPlatform } from "../../../configs/utils";
export const template = (applicationId, isFromPhonePe, height, contactUsDetails, isFromJupiter) => ({
    layout: {
        id: ROUTE.EMAIL_VERIFY,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            { id: 'emailVerifyScreen', type: WIDGET.EMAIL_VERIFY_PAGE },
        ],
    },
    datastore: {
        emailVerifyScreen: {
            height,
            needHelpAction: {
                routeId: ROUTE.EMAIL_VERIFY,
                type: ACTIONS.NEED_HELP,
                payload: { id: 'bt_verifyEmailScreen_needHelp' }
            },
            goBackAction: {
                routeId: ROUTE.EMAIL_VERIFY,
                type: ACTIONS.GO_HOME,
                payload: { id: 'bt_verifyEmailScreen_goBack' }
            },
            googleAction: {
                type: ACTIONS.GOOGLE_LOGIN,
                routeId: ROUTE.EMAIL_VERIFY,
                payload: {},
            },
            emailAction: {
                type: ACTIONS.OTHER_EMAIL,
                routeId: ROUTE.EMAIL_VERIFY,
                payload: { applicationId },
            },
            closeModal: {
                type: ACTIONS.CLOSE_MODAL,
                routeId: ROUTE.EMAIL_VERIFY,
                payload: {},
            },
            contactUsDetails,
            showErrorModal: false,
            errorDescription: '',
            isFromJupiter: isFromJupiter
        },
        stack_root: {
            type: StackType.column,
            width: StackWidth.FULL,
            alignItems: StackAlignItems.flexStart,
            widgetItems: [
                { id: "title", type: WIDGET.TEXT },
                { id: "titleSpace", type: WIDGET.SPACE },
                { id: "subTitle", type: WIDGET.TEXT },
                { id: "subSpace", type: WIDGET.SPACE },
                isFromPhonePe ? {} : { id: "google", type: WIDGET.GOOGLE_BUTTON },
                { id: "space2", type: WIDGET.SPACE },
                { id: "email", type: WIDGET.BUTTON },
                { id: "space3", type: WIDGET.SPACE },
            ],
        },
        // space0: <SpaceProps>{ size: SizeTypeTokens.XXXXL },
        subSpace: { size: SizeTypeTokens.Size32 },
        spaceTop: { size: SizeTypeTokens.MD },
        titleSpace: { size: SizeTypeTokens.SM },
        back: {
            type: ButtonTypeTokens.IconGhost,
            icon: { name: IconTokens.Back, size: IconSizeTokens.XL },
        },
        title: {
            label: "Verify your email",
            fontSize: FontSizeTokens.XL,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: "600",
        },
        subTitle: {
            label: "We’ll use this to send important updates ",
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            color: ColorTokens.Grey_Charcoal,
            numberOfLines: 1,
        },
        customHeader: {
            needHelpAction: {
                routeId: ROUTE.EMAIL_VERIFY,
                type: ACTIONS.NEED_HELP,
                payload: { id: 'bt_verifyEmailScreen_needHelp' }
            },
            goBackAction: {
                routeId: ROUTE.EMAIL_VERIFY,
                type: ACTIONS.GO_HOME,
                payload: { id: 'bt_verifyEmailScreen_goBack' }
            },
        },
        google: {
            id: 'txt_verifyEmailScreen_google',
            label: "Continue with Google",
            action: {
                type: ACTIONS.GOOGLE_LOGIN,
                routeId: ROUTE.EMAIL_VERIFY,
                payload: {},
            },
        },
        email: {
            id: 'txt_verifyEmailScreen_otherEmail',
            label: "Continue with other email",
            type: ButtonTypeTokens.LargeSoftFilled,
            bgColor: ColorTokens.White,
            labelColor: ColorTokens.Primary_100,
            fontSize: FontSizeTokens.SM,
            width: ButtonWidthTypeToken.FULL,
            icon: {
                name: IconTokens.Email,
                size: IconSizeTokens.LG,
                align: IconAlignmentTokens.left,
            },
            paddingVertical: SizeTypeTokens.MD,
            paddingHorizontal: SizeTypeTokens.MD,
            action: {
                type: ACTIONS.OTHER_EMAIL,
                routeId: ROUTE.EMAIL_VERIFY,
                payload: { applicationId },
            },
        },
        space1: { size: SizeTypeTokens.XXL },
        space2: { size: SizeTypeTokens.XXL },
        // space3: <SpaceProps>{ size: SizeTypeTokens.XXL },
    },
});
export const emailVerifyMF = {
    onLoad: async ({ analytics, network, navigate, instrumentTrack, getHeight }, { applicationId }) => {
        const isFromPhonePe = await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */;
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
        const isFromBharatPe = await SharedPropsService.getAppPlatform() === "BHARAT_PE" /* AppPlatform.BHARAT_PE */;
        const isFromBharatPe2 = await SharedPropsService.getAppPlatform() === "BHARAT_PE_2" /* AppPlatform.BHARAT_PE_2 */;
        const isFromParkPlus = await SharedPropsService.getAppPlatform() === "PARKPLUS" /* AppPlatform.PARK_PLUS */;
        const isFromLark = await SharedPropsService.getAppPlatform() === "LARK" /* AppPlatform.LARK */;
        const contactUsDetails = await getContactUsDetails();
        const isFromTdl = isFromTDLPlatform();
        if (isFromPhonePe || isFromJupiter || isFromBharatPe || isFromParkPlus || isFromTdl || isFromBharatPe2 || isFromLark) {
            await navigate(ROUTE.ENTER_EMAIL);
        }
        return Promise.resolve(template(applicationId, isFromPhonePe, getHeight(), contactUsDetails, isFromJupiter));
    },
    actions: {
        [ACTIONS.GOOGLE_LOGIN]: loginGoogle,
        [ACTIONS.OTHER_EMAIL]: otherEmail,
        [ACTIONS.NEED_HELP]: needHelp,
        [ACTIONS.GO_HOME]: goHome,
        [ACTIONS.CLOSE_MODAL]: closeModal,
    },
    clearPrevious: true,
};
